export const DEAL_SCREEN_EXPERIENCE = {
    BASE: 'base' as const,
    DEAL_CENTRAL: 'dealCentral' as const,
    DEAL_CENTRAL_WITH_FNI: 'dealCentralWithFnI' as const,
    MV_LITE: 'mvLite' as const
};

export const BUYER = 'buyer';
export const CO_BUYER = 'coBuyer';
export const VEHICLE_INSURANCE = 'vehicleInsurance';
export const LENDER = 'lender';
export const ACCESSORIES = 'accessories';
export const VEHICLE_ENTITY = 'vehicle';
export const GAP = 'gap';
export const CONTRACT_API_ERRORED_VPP = 'contractApiErroredVPP';
export const CONTRACT_API_ERRORED_VEHICLE_INSURANCE = 'contractApiErroredVehicleInsurance';
export const ENTITY_OTHER = 'other';
export const TRADE_IN = 'tradeIn';
export const TRADE_INS = 'tradeIns';
export const GAP_PRODUCT_CATEGORY_CODE = 'GAP';
